import { gql } from '@apollo/client'

export const FETCH_WIDGET = gql`
  query WidgetActivityPageFetchWidget(
    $widgetSlug: String
    $activitySlug: String
    $locale: String!
  ) {
    widgets(where: { slug: { _eq: $widgetSlug } }) {
      outlet {
        id
        slug
        default_currency
        name
        enthusiast_cancellation_policy
        enable_requests_for_time_slots
        child_age
        widget_show_reviews
        google_places_id
        ratings(where: { service: { _eq: "google" }, score: { _gte: 4 } }) {
          score
          number_of_ratings
          url
        }
        reviews_aggregate {
          aggregate {
            count
          }
        }
        reviews(
          where: { rating: { _gte: 4 } }
          limit: 5
          order_by: { reviewed_at: desc }
        ) {
          id
          rating
          author
          author_image
          text
          reviewed_at
        }
        translations(
          where: {
            language: { _in: [$locale, "en"] }
            field: {
              _in: [
                "custom_cancellation_policy_tagline"
                "custom_cancellation_policy_text"
                "description"
              ]
            }
            model_type: { _eq: "Outlet" }
          }
        ) {
          field
          id
          language
          value_scrubbed
        }
        feature_toggles {
          shopping_basket_enabled
          marketplace_enabled
          approvals_enabled
        }
        #
        # Schedulable
        #
        schedulables(
          where: { slug: { _eq: $activitySlug }, type: { _eq: "Activity" } }
        ) {
          id
          slug
          child_price_pence
          price_pence
          pricing_model
          minimum_capacity
          maximum_capacity
          approval_requirements_aggregate {
            aggregate {
              count
            }
          }
          optional_extras(where: { discarded_at: { _is_null: true } }) {
            id
            price_pence
            schedulable_id
            translations(
              where: {
                language: { _in: [$locale, "en"] }
                field: { _in: ["name"] }
                model_type: { _eq: "OptionalExtra" }
              }
            ) {
              field
              id
              language
              value_scrubbed
            }
          }
          duration_mins
          arrive_before_mins
          image
          members_only
          activity_vouchers_enabled
          schedulable_membership_restrictions {
            membership_product_id
          }
          default_image {
            id
            image
          }
          activity_type {
            id
            name
            key_image
            css_class
          }
          private_activity
          price_points {
            id
          }
          address {
            id
            latitude
            longitude
            post_code
            street_name
            country
            city
            building_name
          }
          location_text
          translations(
            where: {
              language: { _in: [$locale, "en"] }
              field: {
                _in: [
                  "description"
                  "what_to_bring"
                  "itinerary"
                  "requirements"
                  "name"
                  "tagline"
                ]
              }
              model_type: { _eq: "Schedulable" }
            }
          ) {
            language
            field
            value_scrubbed
          }
          type
          allow_exclusive_bookings
          minimum_party_size_for_exclusive
          continuous
          created_at
          time_slot_bookings(
            where: { start: { _gte: now } }
            order_by: { start: asc }
            limit: 5
          ) {
            id
            start
            finish
          }
          category {
            image
            translations(
              where: {
                language: { _in: [$locale, "en"] }
                field: { _in: ["name"] }
                model_type: { _eq: "Category" }
              }
            ) {
              language
              field
              value_scrubbed
            }
          }
        }
      }
      categories_widgets_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`
